import { useMemo } from "react";
import { DashboardResponse } from "src/shared/types";

export const useDashboardVM = (data?: DashboardResponse) => {
  return useMemo(() => {
    if (!data) return null;

    const months = data.monthly_sales_inward_summary.last_six_months;

    return {
      kpis: [
        {
          title: "Total Sales",
          value: data.date_range_res.total_sales,
          icon: "💰",
        },
        {
          title: "Outstanding",
          value: data.overall_outstanding_balance,
          icon: "💳",
        },
        {
          title: "Orders",
          value: data.order_counts.month,
          icon: "📦",
        },
        {
          title: "Received",
          value: data.date_range_res.total_received,
          icon: "✅",
        },
      ],

      // 🔥 Highlight Card (OSB)
      osb: data.overall_outstanding_balance,

      // 🔥 Stock Summary
      stock: data.stock_summary,

      // 🔥 Top Products
      products: data.top_products,

      chart: months.map((m) => ({
        name: m.month,
        sales: m.total_sales,
        outstanding: m.total_outstanding_balance,
      })),

      customers: data.top_customers,
      orders: data.top_orders,
    };
  }, [data]);
};
